import React, { useContext, useEffect, useRef, useState } from "react";
import "./Contact.css";
import { themeContext } from "../../Context";

const SUCCESS_WINDOW_MS = 15000;
const STORAGE_KEY = "contactSuccessAt";

const initialFields = { user_name: "", user_email: "", message: "" };

const Contact = () => {
  const { state } = useContext(themeContext);
  const darkMode = state.darkMode;

  const formRef = useRef(null);
  const timerRef = useRef(null);

  const [done, setDone] = useState(false);
  const [fields, setFields] = useState(initialFields);
  const [touched, setTouched] = useState({});

  const errors = {
    user_name:
      fields.user_name.trim().length < 5 ? "Please enter your name." : "",
    user_email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.user_email)
      ? ""
      : "Enter a valid email address.",
    message:
      fields.message.trim().length < 30 ? "Please enter a longer message." : "",
  };
  const isValid = !errors.user_name && !errors.user_email && !errors.message;

  const clearTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  const scheduleReset = (ms) => {
    clearTimer();
    timerRef.current = setTimeout(() => {
      setDone(false);
      localStorage.removeItem(STORAGE_KEY);
    }, ms);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFields((f) => ({ ...f, [name]: value }));
  };

  const handleBlur = (e) => {
    const { name } = e.target;
    setTouched((t) => ({ ...t, [name]: true }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isValid) {
      setTouched({ user_name: true, user_email: true, message: true });
      return; 
    }

    setDone(true);
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
    scheduleReset(SUCCESS_WINDOW_MS);

    setFields(initialFields);
    formRef.current?.reset();
  };

  useEffect(() => {
    const tsRaw = localStorage.getItem(STORAGE_KEY);
    if (tsRaw) {
      const ts = Number(tsRaw);
      const elapsed = Date.now() - ts;
      if (elapsed >= 0 && elapsed < SUCCESS_WINDOW_MS) {
        setDone(true);
        scheduleReset(SUCCESS_WINDOW_MS - elapsed);
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
    }
    return clearTimer;
  }, []);

  return (
    <div className="contact-form" id="contact">
      <div className="w-left">
        <div className="awesome">
          <span style={{ color: darkMode ? "white" : "" }}>Get in Touch</span>
          <span>Contact Us</span>
          <div className="blur s-blur1" style={{ background: "#ABF1FF94" }} />
        </div>
      </div>

      <div className="c-right">
        <form ref={formRef} onSubmit={handleSubmit} noValidate>
          {!done ? (
            <>
              <input
                type="text"
                name="user_name"
                className="user"
                placeholder="Name"
                value={fields.user_name}
                onChange={handleChange}
                onBlur={handleBlur}
                aria-invalid={!!(touched.user_name && errors.user_name)}
                aria-describedby="name-error"
                required
                minLength={2}
              />
              {touched.user_name && errors.user_name && (
                <span id="name-error" className="field-error">
                  {errors.user_name}
                </span>
              )}

              <input
                type="email"
                name="user_email"
                className="user"
                placeholder="Email"
                value={fields.user_email}
                onChange={handleChange}
                onBlur={handleBlur}
                aria-invalid={!!(touched.user_email && errors.user_email)}
                aria-describedby="email-error"
                required
              />
              {touched.user_email && errors.user_email && (
                <span id="email-error" className="field-error">
                  {errors.user_email}
                </span>
              )}

              <textarea
                name="message"
                className="user"
                placeholder="Message"
                value={fields.message}
                onChange={handleChange}
                onBlur={handleBlur}
                aria-invalid={!!(touched.message && errors.message)}
                aria-describedby="message-error"
                required
                minLength={5}
              />
              {touched.message && errors.message && (
                <span id="message-error" className="field-error">
                  {errors.message}
                </span>
              )}

              <input type="submit" value="Send" className="button" />
            </>
          ) : (
            <span className="success-msg">
              ✅ Your message was successfully sent!
            </span>
          )}

          <div className="blur c-blur1" style={{ background: "var(--purple)" }} />
        </form>
      </div>
    </div>
  );
};

export default Contact;
